export const routes = {
  splash: '/',
  login: '/login',
  teamLogin: '/team/login',
  chooseService: '/choose-service',
  // `caseId` picks a specific case's tracker instead of the page's own "most recent" fallback —
  // needed wherever an investor can have more than one case in flight at once (see
  // `review-status-view.tsx`'s doc comment).
  reviewStatus: (caseId?: string) => (caseId ? `/review-status?case=${caseId}` : '/review-status'),
  staff: {
    home: '/staff',
    clientDetail: (investorId: string) => `/staff/clients/${investorId}`,
    calls: '/staff/calls',
    profile: '/staff/profile',
  },
  admin: {
    home: '/admin',
    cases: '/admin/cases',
    staff: '/admin/staff',
    calls: '/admin/calls',
    investors: '/admin/investors',
    clientDetail: (investorId: string) => `/admin/clients/${investorId}`,
  },
  investor: {
    home: '/dashboard',
    portfolio: '/dashboard/portfolio',
    auditPrescription: '/dashboard/audit',
    trades: '/dashboard/trades',
    build: '/dashboard/build',
    explore: '/dashboard/explore',
    request: (flow: 'audit' | 'trades' | 'build') => `/dashboard/request/${flow}`,
    profile: '/profile',
  },
  kitchenSink: '/kitchen-sink',
} as const
